// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RateNum_wrapper__j0XIC","title":"RateNum_title__SgwaW","input":"RateNum_input__wbZdF","star":"RateNum_star__Su_vC","active":"RateNum_active__G51S_"};